import { Component, OnInit, ViewChild } from '@angular/core';

// Services
import { DataService } from '../../services/data.service';
import { AppService } from '../../services/app.service';
import { Router } from '@angular/router';
import { FreeTrialService } from '../../services/free-trial.service';
import { BsModalService } from 'ngx-bootstrap';

// Components
import { ContractTermsFreeTrialUpgradeModalComponent } from '../contract-terms-free-trial-upgrade-modal/contract-terms-free-trial-upgrade-modal.component';
import { RegisterPaymentComponent } from '../register-payment/register-payment.component';

// Model
import { School } from '../../model/school';
import { PaymentInfo } from '../../model/free-trial';

@Component({
  selector: 'app-free-trial-upgrade-v2',
  templateUrl: './free-trial-upgrade-v2.component.html',
  styleUrls: ['./free-trial-upgrade-v2.component.scss']
})
export class FreeTrialUpgradeV2Component implements OnInit {

	errorMessage: string = ""
    isLoading: boolean = false;
	isUpgrading: boolean = false;
	doneClicked: boolean = false;
	agreed: boolean = false;

	terms: string = `I understand I'm continuing my subscription program, and I authorize ChildPilot to charge my credit card account monthly for the price in effect each period until I cancel, 
	beginning on the 1st of the month, following the end of my free trial. I certify that the information above is correct and understand it will appear on my invoice.`
	chosenPackage: string = "business";

	// Track user's steps in an organized way
	// Also used for html rendering
	steps = [
		{done: false, name: 'choose'},
		{done: false, name: 'payment'},
		{done: false, name: 'done'},
	];
	stepIndex: number = 0;

	// Daycare Admin's FName & LName
	adminFName: string = "";
	adminLName: string = "";

	get currentStep(): {done: boolean,name: string} { return this.steps[this.stepIndex]}
	get isMobile(): boolean { return window.innerWidth < 500;}
	get daycare(): School { return this.dataSvc.daycare || null;}
	get daycareName(): string { 
		if (!this.dataSvc.daycare)
			return 'Free Trial'

		return this.daycare.nameToShow || 'Free Trial ' 
	}

	@ViewChild(RegisterPaymentComponent) RegisterPayment: RegisterPaymentComponent;
	constructor(
		private modalSvc: BsModalService,
		private dataSvc: DataService,
		private appSvc: AppService,
		private router: Router,
		private freeTrialSvc: FreeTrialService
	) { }

	async ngOnInit() {
		this.isLoading = true;
		
		// Get daycare guid from url
		let url = window.location.href
		let daycareAliasEncoded = this.dataSvc.getQueryStringParams(url, 'ID');
		let daycareAlias = atob(decodeURIComponent(daycareAliasEncoded));

		// Send to error page if no GUID
		if (daycareAlias == "") {
			this.isLoading = false;
			this.router.navigate(['error404']);
			return;
		}

		try {
			let daycare = await this.dataSvc.getDaycare(null,daycareAlias, false) as School;
			
			// Verify that the school is a childpilot lite client
			if (daycare && daycare.cpBillingPlan === 'lite' && !daycare.isDeleted) {
				this.dataSvc.daycare = daycare;
				this.parseFirstLastName(daycare.adminName)
			}
			else {
				this.router.navigate(['error404']);
			}
			
		}
		catch(e) {
			this.router.navigate(['error404']);
			console.log(e);
		}

		this.isLoading = false;
	}

	// Called when a pricing plan is chosen
	btnActivatePlan(plan: string) {
		this.chosenPackage = plan;
		this.activateNextStep();
	}

	// called when 'change' is clicked in the 'payment' step
	btnChangePlan() {
		this.activatePreviousStep()
	}

	async btnComplete() {
		try {
			// Prevent someone from clicking the button multiple times
			if (this.isUpgrading)
				return;

			// Make sure agree checkbox is checked
			if (!this.agreed)
				return;

			this.isUpgrading = true;

			// Authorize payment, returns empty if fails in component
			let paymentInfo: PaymentInfo = await this.RegisterPayment.btnDone(this.daycare.alias);
			if (!paymentInfo) {
				throw new Error('form error');
			}

			// Wait for firebase function that marks school as upgraded
			await this.freeTrialSvc.upgradeFreeTrial(this.daycare.name, this.daycare.inviteKey, this.chosenPackage, this.daycare.dynamics.accountID);

			// Send email confirmation
			this.freeTrialSvc.sendFreeTrialUpgradeConfirmation(this.daycare.name, this.daycare.inviteKey, this.chosenPackage);

			// Delete any scheduled emails that are to be sent to this school
			this.freeTrialSvc.deleteFollowUpEmails(this.daycare.name);

			// Create Quickbooks Customer for this daycare
			this.dataSvc.createQuickbooksInvoicePaymentAccount(paymentInfo.cardNumber, paymentInfo.token, paymentInfo.expDate, paymentInfo.zip, paymentInfo.getPayerName(), 0, 0, this.daycare, this.daycare.adminEmail, this.daycare.adminName, 'Neida Toupal').then(() => {
			})

			this.isUpgrading = false;

			// Send to next step
			this.activateNextStep();
		}
		catch(e) {
			this.isUpgrading = false;

			if (e.message && e.message === 'form error')
				return;

			this.appSvc.showAlert('Failed to upgrade. Please try again.', 'danger-custom', true, 5000);
			console.log(e);
		}
	}

	// Get first & last from adminName field so we can populate register-payment fields
	parseFirstLastName(adminName: string) {
		try {
			let nameArr = adminName.split(' ');
			let first = nameArr[0] || "", last = nameArr[1] || "";

			this.adminFName = first.trim();
			this.adminLName = last.trim();
		} catch (e) {
			console.log(e);
		}
	}

	// Increment step
	activateNextStep() {
		this.steps[this.stepIndex].done = true;
		this.stepIndex ++;
	}

	// decrement step
	activatePreviousStep() {
		this.steps[this.stepIndex-1].done = false;
		this.stepIndex --;
	}

    openContractTerms() {
        this.modalSvc.show(ContractTermsFreeTrialUpgradeModalComponent, { initialState: { cpBillingPlan: this.chosenPackage, schoolName: this.dataSvc.daycare.name }});
	}
	
	getActiveClass(packageName: string) {
		if (packageName === this.chosenPackage)
			return 'chosen';

		return '';
	}

	// Returns pricing plan inputs for child component "pricing-plan"
	getPricingPlan(plan: string) {
		return this.PRICING_PLANS[plan];
	}

	getHeaderName(): string {
		switch(this.currentStep.name) {
			case 'choose' : {
				return 'ChildPilot Pricing Plans'
			}
			case 'payment': {
				return 'Review & Finalize';
			}
			case 'done': {
				return 'Congratulations!'
			}
		}
	}

	// Returns bootstrap css
	getBtnWidth() {
		// Make buttons full width on mobile
		if (this.isMobile) {
			return 'w-100'
		}

		// otherwise 50%
		return 'w-50'
	}

	PRICING_PLANS = {
		'lite': {
			planName: "lite",
			header: {
				imgPath: "../../assets/Plan_CPLitePlane.png",
				name: "Lite",
				price: "2.50",
				pricePeriod: 'Child',
				headerColor: "#fcc279a3"
			},
			body: {
				content: [
					["Continued use of the ChildPilot System","30 active children","30 active families","3 active employees"],
					["1 ChildPilot representative", "Access to online payments"]
				]
			}			
		},
		'economy': {
			planName: "economy",
			header: {
				imgPath: "../../assets/Plan_CPEconomyPlusPlane.png",
				name: "Economy Plus",
				price: "100",
				pricePeriod: 'Month',
				headerColor: "#9ace80cf"
			},
			body: {
				content: [
					['31-64 children', 'Unlimited employees & families','500 texts & 1 free digitalized documents per month'],
					["1 ChildPilot representative", "Access to online payments","1 free administrative & staff training","ALL ChildPilot features"]
				]
			}			
		},
		'business': {
			planName: "business",
			header: {
				imgPath: "../../assets/Plan_CPBusinessClassPlane.png",
				name: "Business Class",
				price: "140",
				pricePeriod: 'Month',
				headerColor: "#d592c0cc"
			},
			body: {
				content: [
					['65-99 children', 'Unlimited employees & families','1000 texts & 3 free digitalized documents per month'],
					["1 ChildPilot representative", "Access to online payments","1 free administrative & staff training","ALL ChildPilot features"]
				]
			}		
		},
		'first': {
			planName: "first",
			header: {
				imgPath: "../../assets/Plan_CPFirstClassPlane.png",
				name: "First Class",
				price: "180",
				pricePeriod: 'Month',
				headerColor: "#5093b8d9"
			},
			body: {
				content: [
					['100+ children', 'Unlimited employees & families','5000 texts & 6 free digitalized documents per month'],
					["1 ChildPilot representative", "Access to online payments","1 free administrative & staff training","ALL ChildPilot features"]
				]
			}		
		}
	}

}
